export default {
  GET_SALES_REPORT: 'GET_SALES_REPORT',
  GET_SALES_REPORT_LOADING: 'GET_SALES_REPORT_LOADING',
  GET_SALES_REPORT_SUCCESS: 'GET_SALES_REPORT_SUCCESS',
  GET_SALES_REPORT_FAILED: 'GET_SALES_REPORT_FAILED',
  GET_SALES_REPORT_REJECT: 'GET_SALES_REPORT_REJECT',
};
